import { Capacitor } from '@capacitor/core';

/**
 * Service to update the iOS widget with current game data
 */
export interface GameWidgetData {
  courseName: string;
  courseLayout: string;
  currentHole: number;
  totalHoles: number;
  par: number;
  hcp?: number;
  holeName?: string;
  score: number;
  isActive: boolean;
}

export class WidgetService {
  private static instance: WidgetService;

  /**
   * Get the singleton instance of WidgetService
   */
  public static getInstance(): WidgetService {
    if (!WidgetService.instance) {
      WidgetService.instance = new WidgetService();
    }
    return WidgetService.instance;
  }

  /**
   * Update the iOS widget with current game data WIP
   */
  public async updateGameWidget(gameData: GameWidgetData): Promise<void> {
    if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('MGPWidgetPlugin')) {
      // console.log('Widget plugin not available');
      return;
    }

    try {
      // Call the native plugin to update widget data
      const plugin = (Capacitor as any).Plugins.MGPWidgetPlugin;
      await plugin.updateWidgetData({
        gameData: JSON.stringify(gameData)
      });
      console.log('Widget data updated successfully');
    } catch (error) {
      console.error('Error updating widget data:', error);
    }
  }

  /**
   * Clear the widget data when game is finished
   */
  public async clearGameWidget(): Promise<void> {
    if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('MGPWidgetPlugin')) {
      console.log('Widget plugin not available');
      return;
    }

    try {
      // Call the native plugin to clear widget data
      const plugin = (Capacitor as any).Plugins.MGPWidgetPlugin;
      await plugin.clearWidgetData();
      console.log('Widget data cleared successfully');
    } catch (error) {
      console.error('Error clearing widget data:', error);
    }
  }
}

export const widgetService = WidgetService.getInstance();
